<template>
  <div class="row reverse-mobile" id="my-contracts">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <MyContract
        class="contract shadow rounded"
        v-for="contract in myContracts"
        :key="contract.contract.id"
        :contractId="contract.contract.id"
        :product="contract.contract.product.name"
        :type="contract.contract.agreement_type"
        :number_on_agreement="contract.contract.number_of_licenses_allowed"
        :number_used="contract.number_licenses_for_contract"
        :agreement_date="contract.contract.agreement_creation_date"
        :already_licensed="currentlyLicensed"
        :licenses="contract.contract.licenses"
      ></MyContract>
    </div>
  </div>
</template>

<script>
import licenseService from "../services/license.service";
import MyContract from "../components/MyContract";
import UserMenu from "../components/UserMenu";

export default {
  name: "MyContracts",
  components: {
    MyContract,
    UserMenu
  },
  data: function() {
    return {
      myContractCount: 0,
      myContracts: [],
      currentlyLicensed: 0
    };
  },
  methods: {
    getMyContracts() {
      licenseService.myContracts().then(data => {
        this.myContracts = data.contracts;
        this.myContractCount = data.count;
        this.currentlyLicensed = data.currently_licensed;
      });
    },
    relinquish() {}
  },
  beforeMount() {
    this.getMyContracts();
  }
};
</script>

<style scoped>
.contract {
  padding: 7px;
  margin-bottom: 30px;
}
</style>
